/**
 * pdf.js worker：应用入口调用 setPdfjsWorkerSrc 一次，全局复用同一 Worker 实例。
 * 与 react-pdf 一致从 pdfjs-dist 取 GlobalWorkerOptions，避免多实例未命中 workerPort。
 */
import "./pdfPolyfill";
import * as pdfjs from "pdfjs-dist";
import { getCoreConfig } from "../config";

let workerReady = false;

function initWorker(src: string) {
  pdfjs.GlobalWorkerOptions.workerSrc = src;
  pdfjs.GlobalWorkerOptions.workerPort = new Worker(src, { type: "module" });
  workerReady = true;
}

export function setPdfjsWorkerSrc(src: string) {
  if (typeof window === "undefined" || workerReady) return;
  const url = src.trim();
  if (!url) return;
  initWorker(url);
}

/** 入口未配置时，可读 setCoreConfig({ pdfWorkerFallbackUrl }) */
export function ensurePdfjsWorker(fallbackSrc?: string) {
  if (typeof window === "undefined" || workerReady) return;
  const resolved = (fallbackSrc ?? getCoreConfig().pdfWorkerFallbackUrl)?.trim();
  if (resolved) initWorker(resolved);
}
